export default __webpack_public_path__ + "static/media/0K9A1480.4b10334e.jpg";